import React from 'react';
import { Button } from '../ui/Button';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../../data/content';
import { trackPixelEvent } from '../../utils/metaPixel';
export function FinalCTA() {
  return <section className="py-24 relative" data-id="element-54" data-mp="3mujurk50mcso">
      <div className="container mx-auto px-4" data-id="element-55" data-mp="3mtibisduijzv">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-56" data-mp="3rsbkq8m3nou8">
          <div className="p-6 rounded-2xl bg-surface border border-line flex flex-col justify-between" data-id="element-57" data-mp="3dtbxn5e8ji06">
            <div data-id="element-58" data-mp="3hv6yy9w61vdy">
              <h2 className="text-lg font-bold text-ink mb-1 flex items-start gap-2" data-id="element-59" data-mp="3hvqghphwmhrg">
                <span aria-hidden="true" data-id="element-60" data-mp="33vpgsdddlgdk">📗</span> MEGA PACK COCINA LISTA
              </h2>
              <p className="text-muted text-sm mb-4" data-id="element-61" data-mp="38th6r1ugmsf4">
                6 Tomos + 6 Bonos · Sistema base completo
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-62" data-mp="124uhhbjymz23">
                <span className="text-muted/70 line-through text-sm" data-id="element-63" data-mp="172dzmmjs3vzb">$52.000 ARS</span>
                <span className="text-3xl font-display font-bold text-ink" data-id="element-64" data-mp="q8n7uo8dn9zi">
                  $19.990 <span className="text-sm text-muted font-sans" data-id="element-65" data-mp="q6agxlkn5pab">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth variant="secondary" href={CHECKOUT_BASIC} onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Mega Pack Cocina Lista',
            value: 19990,
            currency: 'ARS'
          })} data-id="element-66" data-mp="z1gputf7knh2">
              → QUIERO MI MEGA PACK
            </Button>
          </div>

          <div className="p-6 rounded-2xl bg-pistachio-100 border border-pistachio-400 flex flex-col justify-between" data-id="element-67" data-mp="gbqx0bv0abrs">
            <div data-id="element-68" data-mp="bdpfvwh54miy">
              <h2 className="text-lg font-bold text-ink mb-1 flex items-start gap-2" data-id="element-69" data-mp="1rpcklsl7w5b7">
                <span aria-hidden="true" data-id="element-70" data-mp="1mqjisxfam2qv">🏆</span> MEGA PACK + SISTEMA TOTAL
              </h2>
              <p className="text-pistachio-800 text-sm mb-4" data-id="element-71" data-mp="1msvvav2a7kwj">
                6 Tomos + 6 Bonos + Cocina Impecable · La solución completa
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-72" data-mp="pavi90rok2kf">
                <span className="text-muted/70 line-through text-sm" data-id="element-73" data-mp="te1ow9ipfvrf">$71.000 ARS</span>
                <span className="text-3xl font-display font-bold text-ink" data-id="element-74" data-mp="ycwcdorma8hv">
                  $27.990 <span className="text-sm text-muted font-sans" data-id="element-75" data-mp="yaimdubsnmh6">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth href={CHECKOUT_PREMIUM} onClick={() => trackPixelEvent('InitiateCheckout', {
            content_name: 'Mega Pack + Sistema Total',
            value: 27990,
            currency: 'ARS'
          })} data-id="element-76" data-mp="5npi51z7452f">
              → QUIERO EL SISTEMA TOTAL
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted font-medium" data-id="element-77" data-mp="3j1srhkrs451x">
          <span className="flex items-center gap-1" data-id="element-78" data-mp="3bj2smn6lfsgv">
            <span aria-hidden="true" data-id="element-79" data-mp="36krjyfs1bo08">🔒</span> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-80" data-mp="36ioq1knrhaq8">
            <span aria-hidden="true" data-id="element-81" data-mp="31k3qlngc2v2u">⚡</span> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-82" data-mp="2xkl6uv090q1l">
            <span aria-hidden="true" data-id="element-83" data-mp="2xm626mue0d0i">🛡️</span> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-84" data-mp="2sm1kithqtc8p">
            <span aria-hidden="true" data-id="element-85" data-mp="2nti65ub8ed2u">💳</span> Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}